import * as React from 'react'
function SvgMail(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 16.225V30.75c0 1.05-.7 1.75-1.75 1.75H7.75C6.7 32.5 6 31.8 6 30.75V16.225l13.125 7.35c.49.245 1.26.245 1.75 0L34 16.225zM32.25 8C33.3 8 34 8.7 34 9.75v2.625l-13.025 7.164a2 2 0 01-1.945-.01L6 12.2V9.75C6 8.7 6.7 8 7.75 8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgMail
